import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=2b68fc5b&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b68fc5b",
  null
  
)

export default component.exports